export default "<div class=\"widget-media\" [@fade]=\"visualState\" #banner></div>"